var _path, _path2, _path3, _path4, _path5, _path6, _g, _path7, _g2, _path8, _g3, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMegaPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 27,
    viewBox: "0 0 33 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8373 16.4416L24.9023 15.3501C25.6132 15.0961 26.0931 14.3922 26.0931 13.5982V8.67931C26.0931 7.88537 25.6132 7.17997 24.9023 6.92742L21.8359 5.83594",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8307 17.2597C21.5103 17.2597 21.2119 17.0449 21.1019 16.7082C20.9685 16.2814 21.1844 15.8228 21.5859 15.6791L24.6495 14.5891C25.0497 14.4454 25.3192 14.0506 25.3192 13.605V8.68604C25.3192 8.24045 25.0497 7.8442 24.6495 7.70196L21.5859 6.61193C21.1831 6.46679 20.9672 6.00813 21.1033 5.58286C21.2394 5.15904 21.6726 4.92971 22.0755 5.07485L25.1404 6.16344C26.1648 6.5292 26.8537 7.5423 26.8537 8.68604V13.6064C26.8537 14.7487 26.1648 15.7618 25.1404 16.1276L22.0755 17.2176C21.993 17.2466 21.9118 17.2612 21.8307 17.2612",
    fill: "#FF9500"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.22544 16.4297L11.365 25.5201H5.54857L3.40625 16.4297",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3743 26.3315H5.55787C5.20448 26.3315 4.89784 26.0775 4.81259 25.716L2.67165 16.6257C2.56852 16.1902 2.81878 15.7504 3.22991 15.6416C3.6383 15.5327 4.05769 15.7983 4.16082 16.2338L6.15739 24.7087H10.3925L8.49084 16.6242C8.38771 16.1902 8.63934 15.7504 9.05048 15.6416C9.45887 15.5327 9.87688 15.7983 9.98001 16.2338L12.1196 25.3242C12.1773 25.5665 12.1251 25.8235 11.9793 26.0194C11.8336 26.2153 11.6108 26.3315 11.3743 26.3315",
    fill: "#FF9500"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6093 0.874251L9.53748 5.59579C9.41372 5.64804 9.31472 5.73368 9.22809 5.83237H1.9816C1.30508 5.83237 0.757812 6.41005 0.757812 7.12416V15.1463C0.757812 15.8589 1.30508 16.4381 1.9816 16.4381H9.22809C9.31472 16.5353 9.4151 16.6224 9.53748 16.6746L20.6093 21.3947C21.1937 21.6444 21.829 21.1915 21.829 20.5268V1.74512C21.829 1.07745 21.1937 0.624604 20.6093 0.874251Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1770_7580",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 23
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H22.6057V22.2796H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1770_7580)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.98969 6.64836C1.73943 6.64836 1.53593 6.86463 1.53593 7.12879V15.1524C1.53593 15.4165 1.73943 15.6313 1.98969 15.6313H9.23618C9.44931 15.6313 9.65282 15.7257 9.7972 15.8897L20.9076 20.649C20.9461 20.6664 20.9832 20.6606 21.0176 20.6359C21.0533 20.6112 21.0712 20.5778 21.0712 20.5314V1.74975C21.0712 1.70476 21.0533 1.66847 21.0189 1.6438C20.9832 1.62057 20.9447 1.61477 20.9076 1.63218L9.83295 6.35372C9.68719 6.51628 9.44794 6.64836 9.23618 6.64836H1.98969ZM20.9516 22.2804C20.7426 22.2804 20.5322 22.2383 20.3328 22.1527L9.25956 17.4326C9.1523 17.3861 9.04917 17.3266 8.95292 17.254H1.98969C0.893779 17.254 0 16.3106 0 15.1524V7.12879C0 5.96909 0.892404 5.02565 1.98969 5.02565H8.95292C9.04917 4.95308 9.1523 4.89502 9.25956 4.84858L20.3328 0.128491C20.8416 -0.0906771 21.4191 -0.0268137 21.877 0.299761C22.3335 0.624883 22.6057 1.16627 22.6057 1.74975V20.5314C22.6057 21.1134 22.3335 21.6548 21.877 21.9814C21.5992 22.1788 21.2761 22.2804 20.9516 22.2804V22.2804Z",
    fill: "#FF9500"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1770_7580",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 28,
    y: 5,
    width: 5,
    height: 5
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.375 5.23438H32.98V9.55967H28.375V5.23438Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1770_7580)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.1439 9.55786C28.9239 9.55786 28.7052 9.45917 28.5526 9.26758C28.2817 8.92213 28.3257 8.41123 28.6502 8.12384L31.7207 5.42126C32.048 5.13532 32.5306 5.18322 32.8029 5.52576C33.0738 5.86975 33.0298 6.38211 32.7039 6.66804L29.6348 9.37063C29.4904 9.4969 29.3171 9.55932 29.1439 9.55932",
    fill: "#FF9500"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1770_7580",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 28,
    y: 13,
    width: 5,
    height: 5
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.375 13.3672H32.98V17.6925H28.375V13.3672Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1770_7580)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.2114 17.6921C32.0381 17.6921 31.8649 17.6312 31.7205 17.5034L28.65 14.8023C28.3255 14.5135 28.2815 14.0026 28.5537 13.6586C28.826 13.316 29.31 13.2681 29.6359 13.5541L32.705 16.2581C33.0309 16.5455 33.0749 17.0564 32.804 17.4004C32.6514 17.5934 32.4327 17.6921 32.2127 17.6921",
    fill: "#FF9500"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.2284 12.3805H29.1579C28.7344 12.3805 28.3906 12.0177 28.3906 11.5706C28.3906 11.1221 28.7344 10.7578 29.1579 10.7578H32.2284C32.6533 10.7578 32.9957 11.1221 32.9957 11.5706C32.9957 12.0177 32.6519 12.3805 32.2284 12.3805Z",
    fill: "#FF9500"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.757812 8.25905H9.84824L21.829 3.21094L21.7163 20.9925L20.6107 21.4048L9.21434 16.4481H1.98023L0.757812 15.5337V8.25905ZM22.247 8.50434L26.0848 9.3157L26.0696 13.8297L25.2666 15.1694L21.829 16.4466L22.247 8.50434Z",
    fill: "#FF7E00"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMegaPhone);
export default __webpack_public_path__ + "static/media/megaPhone.257fc8a311ae3cf3d2d8c35762731d20.svg";
export { ForwardRef as ReactComponent };